/**
 * Formats a person's name to display as "FirstName L" (first name + last initial)
 * @param params - Object containing firstName and lastName
 * @returns Formatted name string with first name and last initial
 */
export function formatNameWithLastInitial(params: { firstName: string; lastName: string }) {
  return `${params.firstName} ${params.lastName.charAt(0)}`.trim();
}
